
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandIndex as ObiOwnShipNoCommandIndexElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-index.js';
 
 
 

 
 export const ObiOwnShipNoCommandIndex = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-index',
   elementClass: ObiOwnShipNoCommandIndexElement,
   events: {
     
   }
  });
 
 